import { render, staticRenderFns } from "./UpdateItem.vue?vue&type=template&id=0e81eaa0&"
import script from "./UpdateItem.vue?vue&type=script&lang=js&"
export * from "./UpdateItem.vue?vue&type=script&lang=js&"
import style0 from "./UpdateItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports